import React, { useEffect, useState, useRef } from "react";
import { Button, Box, Typography } from "@mui/material";
import SignaturePadJS from "components/utils/signature-pad";
import { loadAction } from "redux/reducers/top";
import { useDispatch, useSelector } from "react-redux";
import SignaturePad from "signature_pad";
import AlertComplete from "components/ui/alert-complete";
import axios from "axios";
import { useParams, useHistory } from "react-router-dom";
import DrawerComplete from "components/ui/drawer-complete";
import { makeStyles } from "@mui/styles";
import { rem } from "assets/js/common";

const useStyles = makeStyles((theme) => ({
  sign: {
    "&.sign": {
      "& .sign-wrap": {
        "& .signature": {
          width: "100%",
          backgroudColor: "#FFF4F2",
          border: "1px solid #FFF4F2",
          borderRadius: "10px",
          overflow: "hidden",
        },
      },
    },
    "& .layout-link": {
      paddingTop: rem(15),
      "& button": {
        marginTop: rem(10),
        "& + button": {
          margin: `${rem(10)} 0 0 0`,
        },
      },
    },
  },
}));

export default function PaySign({ location }) {
  const dispatch = useDispatch();
  const [sigPadData, setSigPadData] = useState(null);
  const [sigPad, setSigPad] = useState(null);
  const [alertMode, setAlertMode] = useState("");
  const [open, setOpen] = useState(false);
  const [openDrawer, setOpenDrawer] = useState(false);
  const history = useHistory();
  const { niceCid } = useParams();
  const classes = useStyles();

  useEffect(() => {
    dispatch(loadAction({ back: true, title: "카드 등록 서명", menu: false }));

    let sig = new SignaturePad(document.querySelector("canvas"), {
      onBegin: () => {
        setSigPadData(sigPad.toDataURL()); // data:image/png;base64,iVBORw0K...
        /**
         * signaturePad.toDataURL(); // save image as PNG
         * signaturePad.toDataURL("image/jpeg"); // save image as JPEG
         * signaturePad.toDataURL("image/svg+xml"); // save image as SVG
         * */
      },
    });
    setSigPad(sig);
  }, []);

  const handleAlertOpen = (mode) => {
    setAlertMode(mode);
    setOpen(true);
  };

  const handleAlertClose = () => {
    setOpen(false);
  };

  const handleRestSignature = () => {
    sigPad.clear();
    setSigPadData();
  };

  const handleSubmit = () => {
    console.log("sigPad", sigPad.toData());
    if (sigPad.toData().length == 0) {
      handleAlertOpen("invaild");
    } else {
      convertSign();
    }
  };

  const convertDataUrlToFile = (name) => {
    const dataURL = sigPad.toDataURL("image/png");
    console.log("dataURL", dataURL);
    const decodedURL = dataURL.replace(/^data:image\/\w+;base64,/, "");
    const buf = Buffer.from(decodedURL, "base64");
    const blob = new Blob([buf], { type: "image/png" });
    return new File([blob], `${name}.png`, { type: "image/png" });
  };

  const convertSign = () => {
    let file = convertDataUrlToFile("sign");
    let formData = new FormData();
    console.log("file", file);

    let url = `/api/st/s3/upload?domain=sign`;
    formData.append("file", file);

    axios
      .post(url, formData, {
        headers: {
          "Content-Type":
            "multipart/form-data; boundary=<calculated when request is sent>",
        },
      })
      .then((res) => {
        if (res.data.data) {
          handleComplete(res.data.data);
        }
      });
  };
  const handleComplete = (url) => {
    // alert(JSON.stringify(niceCid));
    axios
      .post(`/api/app/easy-card/modify-sign`, {
        // niceCid: "NABA05226000000000000000007645",
        niceCid: niceCid,
        signUrl: url,
      })
      .then((res) => {
        handleAlertOpen("complete");
      });
  };

  const [width, setWidth] = useState(0);
  const [height, setHeight] = useState(0);
  const ref = useRef(null);

  useEffect(() => {
    setWidth(ref.current.clientWidth);
    setHeight(ref.current.clientHeight);
  }, []);

  window.appBackKeyHandle = () => {
    if (open) {
      handleAlertClose();
      if (alertMode == "complete") {
        history.goBack();
      }
    } else {
      history.goBack();
    }
  };

  return (
    <div className={classes.sign + " sign container nopad"}>
      <h3>서명을 해주세요</h3>
      <div className="sign-wrap">
        <div className="signature" ref={ref}>
          <canvas width={width} height={height} />
        </div>

        <div className="btn-wrap">
          <Button
            variant="outlined"
            color="primary"
            onClick={handleRestSignature}
          >
            서명 초기화
          </Button>
          <Button variant="contained" color="primary" onClick={handleSubmit}>
            완료
          </Button>
        </div>
      </div>

      {alertMode == "invaild" ? (
        <AlertComplete
          open={open}
          handleAlertClose={handleAlertClose}
          text={"서명이 필요합니다"}
          action={() => {
            handleAlertClose();
          }}
        />
      ) : alertMode == "complete" ? (
        <DrawerComplete
          open={open}
          handleDrawerClose={() => {
            history.goBack();
          }}
          text={"카드 등록이 완료 되었습니다"}
          callback={() => {}}
        />
      ) : (
        <></>
      )}
    </div>
  );
}
